import styled from 'styled-components';

export const IconWrap = styled.div`
  /* this is a hack because of the current implementation of Icon component */
  svg {
    display: block;
  }
`;
